import { FetchResponse } from 'types/fetch';
import endpoints from '../endpoints';
import fetchReq from '../fetch';

type FetchRevokeOptions = {
  accessToken: string;
  type: 'access_token' | 'activity_ref' | 'remember_me' | 'secured_id_token';
};

export default function fetchRevoke({
  accessToken,
  type
}: FetchRevokeOptions): FetchResponse<void> {
  return fetchReq({
    body: {
      token: accessToken,
      token_type_hint: type
    },
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    mark: 'revocation',
    method: 'POST',
    url: endpoints.token.revoke
  });
}
